<template>
  <div
    :class="'hero-card' + (link ? ' hero-card--link' : '') + (lighten ? ' hero-card--lighten' : '')"
    @click="onClick"
  >
    <div class="hero-card__text">
      <div v-if="title" class="hero-card__text__title">
        {{ title }}
      </div>
      <div v-if="subtitle" class="hero-card__text__subtitle">{{ subtitle }}</div>
    </div>
    <div class="hero-card__icon">
      <m4-icon v-if="icon" :icon="icon"></m4-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4HeroCard",
  props: {
    title: String,
    subtitle: String,
    icon: String,
    link: String,
    lighten: Boolean
  },
  methods: {
    onClick() {
      if (this.link) {
        location.href = this.link;
      }
    }
  }
};
</script>
